import { getUrlOrigin } from '@monoimin/utils/helpers';
import { ExpertStoryblok, Locales } from '@monoimin/sb-types';
import { knowsAboutDict } from '@monoimin/intl';
import { parseMarkdownToSections } from '@monoimin/templates/components/expert/components/parseMarkdownToSections';

export function getExpertPersonSchemaByStory(
  expert: ExpertStoryblok,
  slug: string,
  locale: Locales,
  site?: MiniSlug
) {
  const sections = parseMarkdownToSections(expert.details || '');

  // в контенте expertDetails может быть несколько секций, но вторая секция всегда содержит образование
  // если вторая секция отсутствует, то берем первую
  // если секций нет, то возвращаем пустой массив
  const education = sections?.[1] || sections?.[0] || null;
  const educationData = education?.items?.filter(Boolean) || [];

  return {
    '@context': 'https://schema.org/',
    '@type': 'Person',
    name: expert.name,
    url: `${getUrlOrigin(locale, site)}/experts/${slug}/`,
    image: {
      '@type': 'ImageObject',
      url: expert.photo?.filename,
      height: 566,
      width: 566,
    },
    jobTitle: expert.description,
    gender: expert.gender,
    sameAs: [
      expert.facebookLink?.cached_url,
      expert.linkedinLink?.cached_url,
      expert.linksForSEO?.map((link) => link.link?.url || link?.cached_url),
    ].filter((el) => Boolean(el)),
    alumniOf:
      educationData.length > 0
        ? educationData.map((eduItem) => ({
            '@type': 'CollegeOrUniversity',
            name: eduItem,
          }))
        : [],
    knowsAbout: knowsAboutDict[locale],
    memberOf: 'Immigrant Invest',
    telephone: expert.phoneNumber,
    worksFor: [
      {
        '@type': 'Organization',
        name: 'Immigrant Invest',
        sameAs: [
          'https://www.facebook.com/immigrant.invest.en/',
          'https://x.com/imin_en/',
          'https://www.instagram.com/immigrant.invest_en/',
          'https://www.linkedin.com/company/immigrantinvest',
          'https://www.youtube.com/channel/UCrAe3MNAHRdWexW7k412cMg',
        ],
      },
    ],
  };
}
